"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_react_test_renderer = __toESM(require("react-test-renderer"), 1);
var import_vitest = require("vitest");
var import_StackToolbar = require("../../layouts/stack-utils/StackToolbar.shared");
var import_useStack = require("../useStack");
(0, import_vitest.describe)("StackStateProvider", function() {
  (0, import_vitest.it)("hands toolbar config to headless implementations", function() {
    var options;
    function Capture() {
      options = (0, import_useStack.useStack)().focused.options;
      return null;
    }
    var state = {
      stale: false,
      type: "stack",
      key: "stack-key",
      index: 0,
      routeNames: [
        "index"
      ],
      routes: [
        {
          key: "index-key",
          name: "index"
        }
      ],
      preloadedRoutes: []
    };
    var descriptors = {
      "index-key": {
        options: (0, import_StackToolbar.appendStackToolbarConfig)({
          title: "Inbox"
        }, {
          placement: "right",
          children: "Share"
        }),
        render: function() {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
            children: "Inbox"
          });
        }
      }
    };
    (0, import_react_test_renderer.act)(function() {
      import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_useStack.StackStateProvider, {
        state,
        descriptors,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Capture, {})
      }));
    });
    (0, import_vitest.expect)(options).toMatchObject({
      title: "Inbox",
      toolbar: {
        right: {
          placement: "right",
          children: "Share"
        }
      }
    });
  });
});
//# sourceMappingURL=useStack.test.js.map
